import { CSSProperties, useRef } from 'react'
import { ReactSketchCanvas, ReactSketchCanvasRef } from 'react-sketch-canvas';
import { IconSave, IconClear } from '../img';

const Signature = ({
    id,
    value,
    onChange,
    text1,
    text2,
    isRequired = true

}: ICanvasSignatureCtrl) => {
    let inputRef = useRef<ReactSketchCanvasRef>(null);
    const styles: CSSProperties = {
        borderRadius: '0px',
        border: "1px solid",
        borderColor: '#E1E1E1',
        boxSizing: 'border-box',
        borderWidth: 'thin',
        height: '150px'
    } as CSSProperties;

    const clear = (e: any) => {
        e.preventDefault();
        inputRef.current?.resetCanvas();
        onChange('', false);
    }

    const saveImg = async (e: any) => {
        e.preventDefault();
        let img = await inputRef.current?.exportImage('png');
        onChange(img ?? '', true);
        inputRef.current?.resetCanvas();
    }


    return (
        <>
            <div className="lbl-input-re-ni mt-30" style={{ fontWeight: 600 }}>
                <span>{text1}</span> {isRequired && <span>*</span>}
            </div>
            <div className="lbl-input-re-ni mt-10" style={{ lineHeight: '20px' }}>
                <span>{text2}</span>
            </div>
            <div className='mt-10' style={{ display: 'flex', justifyContent: '' }}>
                <button className='icon-canvas' onClick={clear}><IconClear /></button>
                <button className='icon-canvas ml-10' onClick={saveImg}><IconSave /></button>
            </div>


            <ReactSketchCanvas
                id={id}
                style={styles}
                width='100%'
                height='400'
                strokeWidth={4}
                canvasColor='#fff'
                strokeColor="#008866"
                backgroundImage={value}
                exportWithBackgroundImage={true}
                ref={inputRef}
                className='mt-20 mb-30'
                svgStyle={{ background: '#fff' }}

            />
        </>
    )
}

export { Signature }